/**
 * Smooth in-page scroll for the landing anchors (Book a demo, How it works …).
 * Honours prefers-reduced-motion so we never force motion on users who opted
 * out. Anchors keep their real `href` for keyboard + open-in-new-tab; this only
 * upgrades the click to a smooth scroll.
 */
export function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (!el) return;
  const reduce =
    typeof window !== 'undefined' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
}
